import { SearchQueryClause } from 'src/features/HubOverview/interfaces/HubOverview';

interface NewSchema {
  Id: string;
  Relation: string;
  Index: number;
  Clause: {
    Values: string[];
    Column: {
      ID: number;
      InternalName: string;
      DisplayName: string;
    };
    Operator: {
      ID: number;
      OperatorInternalName: string;
    };
  };
  QueryGroupInfo: any[];
}

interface OldSchema {
  id: string;
  relation: string;
  clause: {
    column: {
      id: number;
      internalName: string;
      displayName: string;
    };
    operator: {
      id: number;
      operatorInternalName: string;
    };
    values: string[];
  };
  index: number;
  queryGroupInfo: any[];
}

//TODO: Deprecate this once API returns all camelCased props
export const MapQueryGroupSchema = (newSchema: NewSchema[]): OldSchema[] => {
  if (!newSchema) {
    return [];
  }
  return newSchema.map((item) => ({
    id: item.id,
    relation: item.relation,
    clause: {
      column: {
        id: item.clause?.column?.id,
        internalName: item.clause.column?.internalName,
        displayName: item.clause.column?.displayName,
      },
      operator: {
        id: item.clause.Operator.id,
        operatorInternalName: item.clause.Operator.operatorInternalName,
      },
      values: item.clause.values,
    },
    index: item.index,
    queryGroupInfo: item.queryGroupInfo,
  }));
};

export const MapSchemaToArtemisSchema = (oldSchema: OldSchema[]): NewSchema[] => {
  if (!oldSchema) {
    return [];
  }
  return oldSchema.map((item) => ({
    id: item.id,
    relation: item.relation,
    clause: {
      column: {
        id: item.clause?.column?.id,
        internalName: item.clause?.column?.internalName,
        displayName: item.clause?.column?.displayName,
      },
      Operator: {
        id: item.clause?.operator?.id,
        operatorInternalName: item.clause?.operator?.operatorInternalName,
      },
      values: item.clause?.values,
    },
    index: item.index,
    queryGroupInfo: item.queryGroupInfo,
  }));
};

export const MapCustomFilterQueryGroupsToArtemisSearchQueryGroups = (
  oldSchema: IQueryGroup[]
): SearchQueryClause[] => {
  if (!oldSchema) {
    return [];
  }
  return oldSchema.map((item) => ({
    id: item.id,
    relation: item.relation,
    clause: {
      column: {
        id: item.clause?.column?.id,
        internalName: item.clause?.column?.internalName,
        displayName: item.clause?.column?.displayName,
      },
      operator: {
        id: item.clause?.operator?.id,
        operatorInternalName: item.clause?.operator?.operatorInternalName,
      },
      values: item.clause?.values,
    },
    index: item.index,
    queryGroupInfo: item.queryGroupInfo,
  }));
};
